<template>
  <div class="hamburgerMenu-toggle" :class="{ hamburgerMenuOn: menuActiveFlag }">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>

<script>
export default {
  props: {
    menuActiveFlag: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
  .hamburgerMenu-toggle {
    position: relative;
    width: 22px;
    height: 20px;
    display: inline-block;
    cursor: pointer;
    z-index: 1;
    @media screen and (min-width: 414px) {
      width: 25px;
      height: 26px;
      padding-top: 6px;
    }
    @media (hover: hover) {
      &:hover > div {
        background: #A08E33;
      }
    }
  }

  .bar1, .bar2, .bar3 {
    display: flex;
    align-items: center;
    width: 100%;
    height: 3px;
    background: #8B8B8B;
    margin-bottom: 5px;
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @media screen and (min-width: 414px) {
      margin-bottom: 6px;
    }
  }
  .hamburgerMenuOn{
    z-index: 5005;
  }
  .hamburgerMenuOn .bar1 {
    transform-origin: 15% 45%;
    transform: rotate(45deg);
    margin: 0;
  }
  .hamburgerMenuOn .bar2, .hamburgerMenuOn:hover > .bar2 {
    background: transparent;
  }

  .hamburgerMenuOn .bar3 {
    transform-origin: 15% 45%;
    transform: rotate(-45deg);
    margin: 0;
  }
</style>